import { Trans } from 'react-i18next';

import IconMinus from '~icons/ic/round-minus';

import { HubTooltip } from '@adflow/frontend/ui-common';
import { theme } from '@adflow/frontend/ui-theme';

export function HistoryIconMinus() {
	return (
		<HubTooltip title={<Trans ns="common" i18nKey="Removed" />}>
			<IconMinus
				css={{
					width: '1em',
					height: '1em',
					color: theme.colors.keywords.negative,
					'& path': {
						stroke: theme.colors.keywords.negative,
						strokeWidth: '2px',
					},
				}}
			/>
		</HubTooltip>
	);
}
